/* BookerForm */

import React, { useState } from 'react'
import { createSelector } from 'reselect'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  Card,
  CardContent,
  Grid,
  Box,
  Stepper,
  Step,
  StepButton,
  StepConnector,
} from '@mui/material'

import { Space, Steps, Layout, Row } from 'antd'

import ReservationDetailsAgency from './ReservationDetailsAgency'
import ReservationDetailsHotel from './ReservationDetailsHotel'

import PersonalInfo from './PersonalInfo'
import VerifyDetails from './VerifyDetails'
import ShoppingCart from './ShoppingCart'

import {
  makeSelectActiveStep,
  set_active_step,
} from '../../redux/ducks/reservationDetails'
import { makeStyles } from '@material-ui/core/styles'

import './styles.scss'
import ReservationDetailsPrograms from './ReservationDetailsPrograms'
import ReservationDetailsHotelsPerHours from './ReservationDetailsHotelsPerHours'

const stateSelector = createSelector([makeSelectActiveStep], (activeStep) => ({
  activeStep,
}))

const actionDispatch = (dispatch) => ({
  setActiveStep: (step) => dispatch(set_active_step(step)),
})

const useStyles = makeStyles((theme) => ({
  // card: {
  //   borderTopRightRadius: '15px',
  //   borderBottomLeftRadius: '15px',
  //   boxShadow: `6px 0 6px -2px rgba(25, 25, 25, 0.25), 0 2px 4px rgba(25, 25, 25, 0.25)`,
  // },
  participantes: {
    maxWidth: '60%',
    margin: 'auto',
    marginTop: '3%',
  },
  step: {
    backgroundColor: '#191919',
  },
  fontQuicksand: {
    fontFamily: 'Quicksand, sans-serif',
  },
  fontMuli: {
    fontFamily: 'Muli, sans-serif',
  },
  stepIcon: {
    '& .MuiStepLabel-label': {
      fontFamily: 'Muli, sans-serif', // Aplica la fuente Roboto al StepButton label
    },
  },
  indicator: {
    '& .MuiTabs-scroller .PrivateTabIndicator-root-30': {
      backgroundColor: '#1C2A3A !important',
    },
  },
  // button: {
  //   '& .MuiButton-containedPrimary': {
  //     backgroundColor: '#1C2A3A',
  //     margin: 'auto',
  //   },
}))
const BookerForm = ({ type, hotDeal, experience }) => {
  const [isErrorName, setIsErrorName] = useState(false)
  const [isErrorLastName, setIsErrorLastName] = useState(false)
  const [isValidPhone, setIsValidPhone] = useState(true)
  const [isErrorEmail, setIsErrorEmail] = useState(false)
  const [isErrorGiftedName, setIsErrorGiftedName] = useState(false)
  const [isErrorGiftedLastName, setIsErrorGiftedLastName] = useState(false)
  const [isValidGiftedPhone, setIsValidGiftedPhone] = useState(true)
  const [isErrorGiftedEmail, setIsErrorGiftedEmail] = useState(false)
  const { activeStep } = useSelector(stateSelector)
  // const { reservationId, couponId } = useParams()
  const { setActiveStep } = actionDispatch(useDispatch())
  const classes = useStyles()

  // if (!!reservationId && !!couponId) {
  //   setActiveStep(2)
  // }

  const steps = [
    type === 'RESTAURANT' ? 'Pedido' : 'Detalles de reserva',
    'Datos personales',
  ]

  const handleNext = () => {
    setActiveStep(activeStep + 1)
  }

  const handleBack = () => {
    setActiveStep(activeStep - 1)
  }

  const handleStep = (step) => {
    setActiveStep(step)
  }

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        if (type === 'AGENCY') {
          return experience.name === 'Motel' ? (
            <ReservationDetailsHotelsPerHours
              handleNext={handleNext}
              classes={classes}
              hotDeal={hotDeal}
            />
          ) : (
            <ReservationDetailsAgency
              handleNext={handleNext}
              classes={classes}
              hotDeal={hotDeal}
            />
          )
        }

        if (type === 'HOTEL') {
          return (
            <ReservationDetailsHotel
              handleNext={handleNext}
              classes={classes}
              hotDeal={hotDeal}
            />
          )
        }

        if (type === 'PROGRAM' || type === 'TAILORMADE') {
          return (
            <ReservationDetailsPrograms
              handleNext={handleNext}
              classes={classes}
              hotDeal={hotDeal}
            />
          )
        }

        if (type === 'RESTAURANT' || type === 'ECOMMERCE') {
          return <ShoppingCart type={type} handleNext={handleNext} />
        }

        return

      case 1:
        return (
          <Space style={{ display: 'block' }}>
            <Row>
              <PersonalInfo
                handleBack={handleBack}
                handleNext={handleNext}
                hotDeal={hotDeal}
                type={type}
                setIsErrorName={setIsErrorName}
                setIsErrorLastName={setIsErrorLastName}
                setIsErrorEmail={setIsErrorEmail}
                setIsValidPhone={setIsValidPhone}
                setIsErrorGiftedName={setIsErrorGiftedName}
                setIsErrorGiftedLastName={setIsErrorGiftedLastName}
                setIsErrorGiftedEmail={setIsErrorGiftedEmail}
                setIsValidGiftedPhone={setIsValidGiftedPhone}
                isErrorName={isErrorName}
                isErrorLastName={isErrorLastName}
                isErrorEmail={isErrorEmail}
                isErrorGiftedName={isErrorGiftedName}
                isErrorGiftedLastName={isErrorGiftedLastName}
                isErrorGiftedEmail={isErrorGiftedEmail}
                isValidPhone={isValidPhone}
                isValidGiftedPhone={isValidGiftedPhone}
              />
            </Row>
            <Row>
              <VerifyDetails
                handleBack={handleBack}
                type={type}
                hotDeal={hotDeal}
                isErrorName={isErrorName}
                isErrorLastName={isErrorLastName}
                isErrorEmail={isErrorEmail}
                isErrorGiftedName={isErrorGiftedName}
                isErrorGiftedLastName={isErrorGiftedLastName}
                isErrorGiftedEmail={isErrorGiftedEmail}
              />
            </Row>
          </Space>
        )
      // case 2:
      //   return <VerifyDetails handleBack={handleBack} type={type} />
      default:
        return 'Hubo un error al realizar la reservación'
    }
  }
  const { Step } = Steps

  return (
    <Layout direction="vertical" className="container">
      <Steps current={activeStep} size="small" className="stepper">
        {steps.map((label, index) => (
          <Step
            key={label}
            // onClick={() => handleStep(index)}
            className="custom-step"
          >
            {label}
          </Step>
        ))}
      </Steps>
      <Space container spacing={2}>
        {getStepContent(activeStep)}
      </Space>
    </Layout>
    // <Card
    //   className={classes.card}
    //   sx={{
    //     borderTopRightRadius: '15px',
    //     borderBottomLeftRadius: '15px',
    //     boxShadow: `6px 0 6px -2px rgba(25, 25, 25, 0.25), 0 2px 4px rgba(25, 25, 25, 0.25)`,
    //   }}
    //   item
    // >
    //   <CardContent>
    //     <Stepper
    //       activeStep={activeStep}
    //       alternativeLabel
    //       className="stepper"
    //       // sx={{
    //       //   '& .css-n7tliy-MuiStep-root': { padding: '15px' },
    //       // }}
    //       connector={<StepConnector style={{ display: 'none' }} />}
    //       spacing={0}
    //     >
    //       {steps.map((label, index) => (
    //         <Step key={label}>
    //           <StepButton
    //             onClick={() => handleStep(index)}
    //             sx={{
    //               '& .Mui-active': { color: '#1C2A3A !important' },
    //             }}
    //           >
    //             {label}
    //           </StepButton>
    //         </Step>
    //       ))}
    //     </Stepper>
    //     <Box
    //       sx={{
    //         '& .MuiTabs-centered': {
    //           marginTop: '10px',
    //         },
    //       }}
    //     >
    //       <Grid container spacing={2}>
    //         {getStepContent(activeStep)}
    //       </Grid>
    //     </Box>
    //   </CardContent>
    //   {/* <VerifyDetails handleBack={handleBack} type={type} /> */}
    // </Card>
  )
}

export default BookerForm
